import React, { PropsWithChildren, useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { AuthSessionContext } from '@context/AuthContext'
import { BaseModalType } from '@context/ModalsContext'

import { SensitiveData } from '@ui/Privacy/SensitiveData'
import { Modal } from '@ui/components/Modal'

import { formatDate } from '@utils/date.utils'

import { DocumentClientAreaDto } from '@model/DocumentClientAreaDto'
import { NameDto } from '@model/NameDto'

import { DocumentBadgeStatus } from './DocumentBadgeStatus'

import styles from './UploadedDocumentStatusHistory.module.scss'

interface UploadedDocumentStatusHistoryModalProps {
  documentClientArea: DocumentClientAreaDto | undefined
}

// TODO: check the body of this modal
export const UploadedDocumentStatusHistoryModal: BaseModalType<
  UploadedDocumentStatusHistoryModalProps
> = ({ close, documentClientArea }) => {
  const [auth] = useContext(AuthSessionContext)
  const dateFormat = auth?.dateFormatType?.name
  const { t } = useTranslation()

  return (
    <Modal size='sm'>
      <Modal.Header>{t('Profile.Status History')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          <section>
            {documentClientArea?.statusHistory.map((x, index) => (
              <StatusHistoryItem key={index}>
                <StatusHistoryItemDate
                  name={t('Date')}
                  value={formatDate(x.createdDate, { formatType: dateFormat })}
                />
                <StatusHistoryItemStatus name={t('Status')} value={x.status} />
              </StatusHistoryItem>
            ))}
          </section>
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Got It')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}

const StatusHistoryItem: React.FunctionComponent<PropsWithChildren> = ({ children }) => {
  return <div className={styles.documentItemWrapper}>{children}</div>
}

interface StatusHistoryItemDateProps {
  name: string
  value: string
}

const StatusHistoryItemDate: React.FC<StatusHistoryItemDateProps> = ({ name, value }) => {
  return (
    <dl className={styles.documentItem}>
      <dt className={styles.documentName}>{name}</dt>
      <dd>
        <SensitiveData>{value}</SensitiveData>
      </dd>
    </dl>
  )
}

interface StatusHistoryItemStatusProps {
  name: string
  value: NameDto
}

const StatusHistoryItemStatus: React.FC<StatusHistoryItemStatusProps> = ({ name, value }) => {
  return (
    <dl className={styles.documentItem}>
      <dt className={styles.documentName}>{name}</dt>
      <dd>
        <DocumentBadgeStatus {...value} />
      </dd>
    </dl>
  )
}
